import React, { useState, useEffect, Fragment, useContext } from "react";

import {
  BrowserRouter as Router,
  Link,
  useLocation,
  withRouter,
} from "react-router-dom";
import styled from "styled-components";



import MaterialIcon from 'material-icons-react';

import { Icon, Tooltip } from 'xsolla-uikit';
import { XbeContext } from '../be/CardsPage';




export const CMScardActions = (props) => {
  const context = useContext(XbeContext);

  const { history, salesCardId, utm } = { ...props };

  return (
    <CSScardActions0>
      <Tooltip label="Show integration steps">
      <CSScardAction
        target="_self"
        // href={`/cms/all?edit=${props['salesCardId']}`}
        onClick={() =>
          history.push(
            // `?edit=${salesCardId}&filters=${context["filters"].toString()}`
            `/card/${salesCardId}`
          )
        }
      >
        {/* <CssIcon size={16} left>
          settings
        </CssIcon> */}
          <MaterialIcon color='currentColor' icon='list'/>
      </CSScardAction>
        </Tooltip>


        {/* <CssIcon size={16} left>new_tab</CssIcon> */}
        <Tooltip label="Create email template">
      <CSScardAction
        href={`/card-email/${salesCardId}`}
      >
          <MaterialIcon color='currentColor' icon='mark_email_unread'/>
      </CSScardAction>
        </Tooltip>

        <Tooltip label="One pager">
      <CSScardAction
        href={`/card-onepager/${salesCardId}`}
      >
        {/* <CssIcon size={16} left>new_tab</CssIcon> */}
          <MaterialIcon color='currentColor' icon='contact_mail'/>
      </CSScardAction>
        </Tooltip>


        <Tooltip label="Edit in Admins">
      <CSScardAction
        target="_blank"
        // href={`https://admins.xsolla.com/upsell/integration?campaign_id=${utm}`}
        // onClick={() =>
        //   history.push(
        //     `https://admins.xsolla.com/upsell/integration?campaign_id=${salesCardId}`
        //   )
        // }
      >
        {/* <CssIcon size={16} left>new_tab</CssIcon> */}
          <MaterialIcon color='currentColor' icon='construction'/>
      </CSScardAction>
        </Tooltip>


    </CSScardActions0>
  );
};


const CSScardActions0 = styled.div`
  position: absolute;
  width: 100%;
  top: 0px;
  height: 162px;
  text-align: center;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
  & a {
    transition: opacity 150ms ease-in-out;
    opacity: 0;
  }
  &:hover a {
    opacity: 1;
  }
`;

const CSScardAction = styled.a`
  display: flex;
  background: white;
  text-decoration: none;
  /* padding: 0.4em 1em 0em 1em; */
  padding: 0em 1em;
  border-radius: 4;
  justify-content: center;
  align-items: center;
  color: black;
  border-radius: 3px;
  flex-grow: 0;
  min-width: 44px;
  min-height: 44px;
  margin: 0 4px;
  cursor: pointer;
  &:hover {
    color: #0073f7;
  }
`;